import _ from 'lodash';

const userValidation = /^(?!.*[+\(\),])[\p{L}\p{M}\s'-.]+$/u;

export const isValidUnicodeUserName = (userName) => {
    return userValidation.test(userName);
}